import { Component, ComponentInterface, h, Host, Prop, Element } from '@stencil/core';
import { Icons } from './Icons';
import { IconsGlow } from './Icons.glow';
import { getMode } from '@stencil/core';

export type IconName = keyof typeof Icons;

@Component({
  tag: 'ds-icon',
  styleUrls: {
    default: 'ds-icon.scss',
    light: 'ds-icon.scss'
  },
  shadow: true
})
export class Icon implements ComponentInterface {
  /** Specifies which icon to use from the built-in set of icons */
  @Prop() name: IconName;
  /**
   * (optional) The size of the icon.
   * Available options are: `"small"` and `"big"`.
   */
  @Prop() size?: 'small' | 'big';
  @Prop() iconRole?: string = 'img';

  @Element() el: HTMLDsIconElement;

  render() {
    let icons = Icons;
    if (getMode(this) == 'light') {
      icons = {
        ...icons,
        ...IconsGlow
      };
    }
    let icon = icons[this.name];
    const isRTL = window.getComputedStyle(this.el).getPropertyValue('direction') === 'rtl';
    return (
      <Host
        aria-label={this.name !== undefined ? `icon-${this.name}` : null}
        role={this.iconRole}
        class={{
          [`icon--${this.size}`]: !!this.size,
          [`icon--${this.name}`]: !!this.name
        }}
      >
        <span
          innerHTML={icon}
          class={{
            icon__inner: true,
            'icon__inner--rtl': isRTL
          }}
        />
      </Host>
    );
  }
}
